import { render } from "./scatter.vue?vue&type=template&id=c429a914&scoped=true"
import script from "./scatter.vue?vue&type=script&lang=js"
export * from "./scatter.vue?vue&type=script&lang=js"

import "./scatter.vue?vue&type=style&index=0&id=c429a914&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c429a914"]])

export default __exports__